import { AlertCircle, CheckCircle2 } from 'lucide-react'

/**
 * Small verified / unverified indicator used inline next to portal
 * identifier values (phone, email). Icon-only with an sr-only label so
 * assistive tech reads sensibly.
 *
 * Verified: green success tick.
 * Unverified: destructive alert, drawing attention to the fact that the
 * field needs action to unlock the features it gates.
 */
export function VerificationBadge({ verified }: { verified: boolean }) {
  return verified ? (
    <span className="inline-flex items-center text-success" title="Verified">
      <CheckCircle2 className="size-4" aria-hidden="true" />
      <span className="sr-only">Verified</span>
    </span>
  ) : (
    <span className="inline-flex items-center text-warning" title="Unverified">
      <AlertCircle className="size-4" aria-hidden="true" />
      <span className="sr-only">Unverified</span>
    </span>
  )
}
